import {useEffect, useState} from "react";
import { useLocalStorage, useLocalStorageWithParsing } from "../Context/LocalStorageContext";
import {StepDesc, StepHeader} from "./SectionHeader";
import { ArrowUpRight, Loading } from "../../svg/Icons";
import TextAreaHeader from "./MPKArea";    
import MPKArea from "./MPKArea";
import Alerts from "../Alerts/Alerts";
import { useNavigate } from "react-router-dom";
import GoogleAnalytics from "../GA";


const GenerateMasterKey = () => {

    // MPK INIT
    const [mpk, setMpk] = useLocalStorage("mpk");
    const [sessionId, setSessionId] = useLocalStorage("sessionId");
    const [_, setSteps] = useLocalStorageWithParsing("steps", 0)

    const [loadingGenerate, setLoadingGenerate] = useState(false);
    const [loadingMPK, setLoadingMPK] = useState(false);
    const navigate= useNavigate();

    const generateKeyPair = () => {

        // Trigger loading & disable btn
        setLoadingGenerate(true);

        let apiUrl = (process.env.REACT_APP_ARKG_API_URL) || "http://localhost:4000/api/v1";
        let apiPrefix = process.env.REACT_APP_ARKG_GENERATE_SEED_ENDPOINT || "/generate_seed";
        fetch(`${apiUrl+apiPrefix}?user_id=${sessionId}`)
            .then(res => res.json())
            .then(json => {
                setSteps(1);
                setMpk(JSON.stringify(json));
                setLoadingGenerate(false);
            })
            .catch(err => {console.log(err); setLoadingGenerate(false);
                navigate("/idt/v2/error",{state:{"error": err}});
            });
    }

    const requestMPK = () => {
        if (mpk){
            navigator.clipboard.writeText(JSON.stringify(JSON.parse(mpk),null,2) || '');
        }

        setLoadingMPK(true);
        let apiUrl = (process.env.REACT_APP_ARKG_API_URL) || "http://localhost:4000/api/v1";
        let apiPrefix = process.env.REACT_APP_ARKG_LOGIN_ENDPOINT || "/auth/login";
        fetch(`${apiUrl+apiPrefix}?scope=${process.env.REACT_APP_AUTH0_REGISTER_MPK_SCOPE}`)
            .then(res => res.json())
            .then(json => {
                window.location.href = json;
                //setLoadingMPK(false);
            })
            .catch(err => {
                console.log(err);
                setLoadingMPK(false);
                navigate("/idt/v2/error",{state:{"error": err}});
            });
    }

    const copyMPK = () => {
        if (mpk){
            navigator.clipboard.writeText(JSON.stringify(JSON.parse(mpk),null,2) || '');
        }
    }

    return (

        <div className=" flex w-full gap-14">

            {!mpk &&
                <div className="flex flex-col gap-4">
                    <StepHeader step="step_1_generate_master_key" />
                    <div>
                        <StepDesc step="step_1_generate_master_key" />

                        <p className='text-gray-500 leading-loose text-base font-normal'>Click <span className="font-bold text-base text-primary-600">Generate MPK</span> to proceed.</p>
                    </div>

                    <div>
                        <button onClick={() => {generateKeyPair(); GoogleAnalytics("Generate MPK", "btn_generateMPK", "Button to generate MPK")}}
                            disabled={loadingGenerate}
                            className=" button-primary mb-2 disabled:cursor-not-allowed disabled:bg-primary-400 dark:bg-primary-800 dark:disabled:bg-primary-500">
                                {!loadingGenerate ? "Generate MPK" : <><Loading/>Generating MPK</>}
                        </button>
                    </div>
                </div>
            }

            {mpk && <div className=" w-full">
                
                <MPKArea mpk={mpk} title={"Master Public Key"}/>

                <Alerts step="alert_generated_master_key"/>

                <div className="flex flex-col mt-12 gap-4">
                    <StepHeader step="step_2_register_mpk" />

                    <div>
                        <StepDesc step="step_2_register_mpk"/>
                        <p className='text-gray-500 leading-loose text-base font-normal'><span className="font-bold text-base text-primary-600 cursor-pointer" onClick={() => {copyMPK();GoogleAnalytics("Generate MPK", "btn_copyMPK", "Button to copy MPK")}}>Copy your MPK</span> and click <span  className="font-bold text-base text-primary-600 ">Register</span> to register your MPK.</p>
                    </div>
                
                    <div>
                        <button onClick={() => {requestMPK(); GoogleAnalytics("Generate MPK", "btn_register", "Button to register MPK")}} disabled={loadingMPK} className="button-primary my-2 dark:bg-primary-800">
                            {!loadingMPK ? <>Register <ArrowUpRight className="size-4 text-white"/></> : <><Loading/>Registering</>} 
                        </button>
                    </div>
                </div>
            </div>

            }
        </div>
    )
}

export default GenerateMasterKey;
